import { NgModule } from '@angular/core';
import { LIB_CommonModule } from 'pbc.angular';
import { PostKalkulationHochladenCommandService } from '.';

@NgModule({
  imports: [
    LIB_CommonModule,
  ],
  providers: [PostKalkulationHochladenCommandService],
  exports: []
})
export class PostKalkulationHochladenCommandServiceModule { }
